import { useNavigation } from 'react-router-dom';

const SubmitBtn = ({ formBtn, buttonText }) => {
  const navigate = useNavigation();
  const isSubmitting = navigate.state === 'submitting';
  let textToShow;

  switch (buttonText) {
    case 'כניסה':
      textToShow = isSubmitting ? 'נכנס...' : 'כניסה';
      break;
    case 'שמירה':
      textToShow = isSubmitting ? 'שומר...' : 'שמירה';
      break;
    case 'סגירה': // Add your custom button text case here
      textToShow = isSubmitting ? 'סוגר...' : 'סגירה';
      break;
    default:
      textToShow = buttonText; // Default to showing the buttonText provided if no case matches
  }

  return (
    <button
      type='submit'
      className={`btn btn-block ${formBtn && 'form-btn'}`}
      disabled={isSubmitting}
    >
      {textToShow}
    </button>
  );
};

export default SubmitBtn;
